var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lat && _vm.lon
    ? _c(
        "div",
        [
          _c(
            "gmap-map",
            {
              ref: "gmap",
              staticStyle: { width: "100%", height: "300px" },
              attrs: {
                center: _vm.position,
                zoom: 16,
                "map-type-id": "roadmap",
                options: _vm.mapOptions,
              },
            },
            [
              _c("gmap-marker", {
                attrs: {
                  position: _vm.position,
                  clickable: true,
                  draggable: true,
                },
                on: {
                  click: function ($event) {
                    _vm.center = { lat: 10, lng: 10 }
                  },
                  dragend: _vm.dragEnd,
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }